import { ref, nextTick } from 'vue';

export function useTextarea(onSubmit) {
    const textareaRef = ref(null);

    const adjustHeight = async () => {
        await nextTick();
        const el = textareaRef.value;
        if (el) {
            el.style.height = 'auto';
            el.style.height = el.scrollHeight + 'px';
        }
    };

    const handleKeydown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            onSubmit();
        }
    };

    return { textareaRef, adjustHeight, handleKeydown };
}
